import Contenido from './Contenido';
import Footer from './Footer';
import Header from './Header';
import SideNav from './SideNav';

const Page = (props) => {
    return (
        <>
            <Header></Header>
            <SideNav></SideNav>
            <Contenido datos={props.datos.titulo}>
                {props.children}
            </Contenido>
            <Footer />
        </>
    );
}

export default Page;